import { render, staticRenderFns } from "./ReaPhone.vue?vue&type=template&id=5fee7d40&"
import script from "./ReaPhone.vue?vue&type=script&lang=js&"
export * from "./ReaPhone.vue?vue&type=script&lang=js&"
import style0 from "./ReaPhone.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Freassurance&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports